<script setup lang="ts">
  import { IconSearch, IconLogoShopFlowGo } from "@ui-kit";
  import { default as MainPageAvatar } from "./MainPageAvatar.vue";

  const emit = defineEmits<{ (e: "click:avatar"): void; (e: "click:search"): void }>();
</script>

<template>
  <div class="main-page__header">
    <MainPageAvatar @click="emit('click:avatar')" />
    <IconLogoShopFlowGo />
    <IconSearch @click="emit('click:search')" data-testid="product-search-btn" />
  </div>
</template>

<style scoped>
  .main-page__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px 0 14px;

    & :deep(.avatar) {
      position: absolute;
      top: 4px;
    }
  }
</style>
